import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowSpaceBetween: {
        justifyContent: "space-between",
        flexDirection: "row"
    },
    rowContainer: {
        flexDirection: "row"
    },
    borderedCard: {
        borderRadius: 12
    },
    borderedCard2: {
        borderRadius: 8
    }
});
export default stylesheet;
